import { DataModelBuilder, SerializationContext, SerializedData } from '../../../dto/data-model.js';
import { Payload } from '../payload.js';
import { PayloadType } from '../payload-type.js';
import { MapUtils } from '../../../../utility/map-utils.js';

export class WhisperPayload extends Payload {
  static readonly TYPE_ID = '031922fac3774a3381b6d24e1472d46a';

  private constructor(
    public readonly target: string,
  ) {
    super();
  }

  get $typeId(): string {
    return WhisperPayload.TYPE_ID;
  }

  get type(): PayloadType {
    return PayloadType.Whisper;
  }

  static create(args: {
    target: string;
  }): WhisperPayload {
    return new WhisperPayload(args.target);
  }

  static fromMap(context: SerializationContext, map: SerializedData): WhisperPayload {
    return WhisperPayload.create({
      target: MapUtils.getString(map, 'target'),
    });
  }

  toMap(_context: SerializationContext): SerializedData {
    return {
      'target': this.target,
    };
  }

  clone(): this {
    return this.copyWith();
  }

  copyWith({
    target = this.target,
  }: {
    target?: string;
  } = {}): this {
    return WhisperPayload.create({ target }) as this;
  }

  isSame(other: WhisperPayload): boolean {
    return this === other || (
      this.target === other.target
    );
  }
}

export class WhisperPayloadBuilder extends DataModelBuilder<WhisperPayload> {
  build(context: SerializationContext, map: SerializedData): WhisperPayload {
    return WhisperPayload.fromMap(context, map);
  }
}
